import NotFound from './NotFound';

const notfound = {
  NotFound,
};

export default notfound;
